import EditCommand from "@app/util/undo/EditCommand";

interface EditListCommand<T> extends EditCommand<T[]> {}

export class AddItemsCommand<T> implements EditListCommand<T> {
  private readonly items: T[];
  private readonly getKey: (item: T) => unknown;

  constructor(itemsToAdd: T[], getKey: (item: T) => unknown) {
    this.items = itemsToAdd;
    this.getKey = getKey;
  }

  apply(list: T[]): T[] {
    const existingKeys = new Set(list.map(this.getKey));
    return [...list, ...this.items.filter((item) => !existingKeys.has(this.getKey(item)))];
  }

  revert(list: T[]): T[] {
    const keysToRemove = new Set(this.items.map(this.getKey));
    return list.filter((item) => !keysToRemove.has(this.getKey(item)));
  }
}

// could probably take AddItemCommand command with swapped apply/revert methods, but
// it's not very reliable, so instead implemented this command from scratch
export class RemoveItemsCommand<T> implements EditListCommand<T> {
  private readonly items: T[];
  private readonly getKey: (item: T) => unknown;

  constructor(itemsToRemove: T[], getKey: (item: T) => unknown) {
    this.items = itemsToRemove;
    this.getKey = getKey;
  }

  apply(list: T[]): T[] {
    const keysToRemove = new Set(this.items.map(this.getKey));
    return list.filter((item) => !keysToRemove.has(this.getKey(item)));
  }

  revert(list: T[]): T[] {
    const existingKeys = new Set(list.map(this.getKey));
    return [...list, ...this.items.filter((item) => !existingKeys.has(this.getKey(item)))];
  }
}
